export var FeedType;
(function (FeedType) {
    FeedType["Address"] = "address";
    FeedType["Author"] = "author";
    FeedType["CreatedAt"] = "created_at";
    FeedType["DVM"] = "dvm";
    FeedType["Difference"] = "difference";
    FeedType["ID"] = "id";
    FeedType["Intersection"] = "intersection";
    FeedType["Global"] = "global";
    FeedType["Kind"] = "kind";
    FeedType["List"] = "list";
    FeedType["Label"] = "label";
    FeedType["WOT"] = "wot";
    FeedType["Relay"] = "relay";
    FeedType["Scope"] = "scope";
    FeedType["Search"] = "search";
    FeedType["Tag"] = "tag";
    FeedType["Union"] = "union";
})(FeedType || (FeedType = {}));
export var Scope;
(function (Scope) {
    Scope["Followers"] = "followers";
    Scope["Follows"] = "follows";
    Scope["Network"] = "network";
    Scope["Self"] = "self";
})(Scope || (Scope = {}));
//# sourceMappingURL=core.js.map